<template>
    <section class="m-contactsearchtop">
        <div class="container">
            <p>Showing {{resultsLoaded}} of {{resultCount}} Contacts</p>

            <span>
                Sort by:
                <select id="sortBy" v-model="orderBy">
                    <option value="4" selected>A-Z</option>
                    <option value="5">Z-A</option>
                </select>
            </span>
        </div>
    </section>
</template>

<script>
    import { truncate } from '@/utils/strings.js'

    export default {
        computed: {
            resultCount: function () {
                return this.$store.state.search.resultCount
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            }
        },

        created: function () {
            this.updateOrderBy()
        },

        data() {
            return {
                orderBy: 4
            }
        },

        methods: {
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            },

            updateOrderBy: function () {
                this.$store.dispatch('updateSearchFilter', { key: 'orderBy', value: this.orderBy })
            }
        },
        
        watch: {
            orderBy: function () {
                this.updateOrderBy()

                this.$eventHub.$emit('search-filtersChanged')
            }
        }
    }
</script>